export default __webpack_public_path__ + "static/media/SAS0240.34I-38841_-22812_0.6a6fe47d.jpg";